import MDSnackbar from "components/MDSnackbar";
import { useEffect, useRef } from "react";

export default function CTLNotification(props) {
  const { notify, setNotify } = props;
  const timerRef = useRef(null);

  const handleClose = (event, reason) => {
    setNotify({
      ...notify,
      isOpen: false,
    });
  };

  useEffect(() => {
    if (notify.isOpen) {
      timerRef.current = setTimeout(() => {
        setNotify({
          ...notify,
          isOpen: false,
        });
      }, 5000);
    } else {
      clearTimeout(timerRef.current);
    }

    return () => clearTimeout(timerRef.current);
  }, [notify]);

  let status = notify.status;
  let message;

  if (status === "OK") {
    message = "200 OK";
  } else if (status === 400) {
    message = " 400 Bad Request";
  } else if (status === 401) {
    message = "401 Unauthorized";
  } else if (status === 402) {
    message = "402 Payment Required";
  } else if (status === 403) {
    message = "403 Forbidden";
  } else if (status === 404) {
    message = "404 Not Found";
  } else if (status === 405) {
    message = "Method Not Allowed";
  } else if (status === 406) {
    message = "406 Not Acceptable";
  } else if (status === 407) {
    message = "407 Proxy Authentication Required";
  } else if (status === 408) {
    message = " 408 Request Timeout";
  } else if (status >= 409 && status <= 699) {
    message = "Server Error. Contact the administrator";
  } else {
    message = status;
  }

  const isWebView21 = () => {
    return (
      /wv|WebView|Edge\/\d+/i.test(navigator.userAgent) ||
      window.isWebView21 === true
    );
  };

  if (isWebView21() && notify.isOpen) {
    try {
      console.log("Notification event data send : ", notify);
      const data = {
        type: notify?.type,
        pagename: notify?.pagename,
        message: notify?.message,
        status: notify?.status,
      };
      const message = JSON.stringify({ eventType: "notification", data: data });
      if (window?.chrome?.webview?.postMessage) {
        window.chrome.webview.postMessage(message);
      } else {
        console.error(
          "WebView2 environment detected but postMessage is not available."
        );
      }
    } catch (error) {
      console.error("Failed to send notification to WebView2:", error);
    }
  }

  if (!notify.isOpen) return null;

  return (
    <>
      <MDSnackbar
        color={notify.type}
        icon={
          notify.type === "success" ? "check" : notify.type
        }
        title={notify.pagename}
        content={message}
        subContent={notify.message}
        status={notify.status}
        open={notify.isOpen}
        close={handleClose}
        autoHideDuration={4000}
      />
    </>
  );
}
